import React from 'react';
import { APP_NAME } from '../../config/appConstants';
import PublicInfoLayout from '../../shared/components/layouts/PublicInfoLayout';
import './LegalPages.css';

export default function SupportPage() {
  return (
    <PublicInfoLayout>
      <h1>Support</h1>
      <p className="legal-subtitle">{APP_NAME} help and troubleshooting</p>

      <h2>Common issues</h2>
      <ul>
        <li><strong>Can’t sign in</strong>: confirm your email, password, and that your account is active.</li>
        <li><strong>Session expired</strong>: sign in again; if it repeats, contact your administrator.</li>
        <li><strong>Missing access</strong>: your role may not include the module you’re trying to use.</li>
      </ul>

      <h2>Need help?</h2>
      <p>
        Please contact your organization’s administrator or IT/support desk. Include screenshots (if allowed),
        the page you were on, and the approximate time of the issue.
      </p>
    </PublicInfoLayout>
  );
}

